import { render } from "./ListPageHeader.vue?vue&type=template&id=2782aada&scoped=true"
import script from "./ListPageHeader.vue?vue&type=script&lang=js"
export * from "./ListPageHeader.vue?vue&type=script&lang=js"

import "./ListPageHeader.vue?vue&type=style&index=0&id=2782aada&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2782aada"]])

export default __exports__